module.exports = __webpack_public_path__ + "static/media/BG.8fea0c24.png";